import type { FC, ReactNode, SVGProps } from 'react'

// Four-point sparkle used as a brand ornament.
export const Star: FC<SVGProps<SVGSVGElement>> = (props): ReactNode => {
    return (
        <svg viewBox='0 0 24 24' fill='currentColor' aria-hidden='true' focusable='false' {...props}>
            <path d='M12 0c.6 6.6 5.4 11.4 12 12-6.6.6-11.4 5.4-12 12-.6-6.6-5.4-11.4-12-12C6.6 11.4 11.4 6.6 12 0Z' />
        </svg>
    )
}
